import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";

import {callApiV2} from '../../../services/server_apiV2';
import {API_URLS} from '../../../consts/consts';

import {DateRangePicker, CustomProvider} from 'rsuite';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";

import {MeasurementsTableData} from "./MeasurementsTableData";
import {MeasurementsCharts} from "./MeasurementsCharts";

import deDE from 'rsuite/locales/de_DE'

import subDays from 'date-fns/subDays';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import startOfDay from 'date-fns/startOfDay';
import endOfDay from 'date-fns/endOfDay';
import addMonths from 'date-fns/addMonths';
import CustomSwitch from "../../../components/CustomSwitch/CustomSwitch";
import {MetricsCharts} from "./MetricsCharts";

const {afterToday} = DateRangePicker;
const getPredefinedRanges = (t) => [
    {
        label: t('Today'),
        value: [startOfDay(new Date()), endOfDay(new Date())],
        placement: 'left'
    },
    {
        label: t('Yesterday'),
        value: [startOfDay(addDays(new Date(), -1)), endOfDay(addDays(new Date(), -1))],
        placement: 'left'
    },
    {
        label: t('Last 7 days'),
        value: [subDays(new Date(), 6), new Date()],
        placement: 'left'
    },
    {
        label: t('Last 30 days'),
        value: [subDays(new Date(), 29), new Date()],
        placement: 'left'
    },
    {
        label: t('This month'),
        value: [startOfMonth(new Date()), new Date()],
        placement: 'left'
    },
    {
        label: t('Last month'),
        value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
        placement: 'left'
    },
    {
        label: t('Last 3 months'),
        value: [startOfMonth(addMonths(new Date(), -3)), endOfMonth(addMonths(new Date(), -1))],
        placement: 'left'
    },
];

const ACTIVE_SCREENS = ["Metering", "Metrics"]

const PopUpSmartReaderInfo = ({open, handleClose, smartReader}) => {
    const {t, i18n} = useTranslation()
    const [activeScreen, setActiveScreen] = useState(ACTIVE_SCREENS[0]);
    const [measurements, setMeasurements] = useState([]);
    const [metrics, setMetrics] = useState([]);
    const [dateRange, setDateRange] = useState([subDays(new Date(), 6), new Date()]);


    useEffect(() => {
        if (!dateRange) return;

        const fromDate = startOfDay(dateRange[0])
        const toDate = endOfDay(dateRange[1])

        callApiV2({
            url: API_URLS.METERING, method: 'post', data: {
                "meter_id": smartReader.meter.id,
                "from_date": fromDate,
                "to_date": toDate,
            }
        }).then(
            (res) => {
                if (res.success) {
                    setMeasurements(res.data.reverse())
                } else return Promise.reject(new Error(res.data));
            }
        )

        callApiV2({
            url: `${API_URLS.SMART_READERS}${smartReader.eui}/rx_metrics/?from_date=${fromDate.toISOString()}&to_date=${toDate.toISOString()}`,
            method: 'get'
        }).then(
            (res) => {
                if (res.success) {
                    setMetrics(res.data)
                } else return Promise.reject(new Error(res.data));
            }
        )
    }, [dateRange, smartReader]);


    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth={true}
            maxWidth={'lg'}
        >
            <DialogTitle>{t('Meter State')}</DialogTitle>
            <DialogContent sx={{height: "100vh"}}>
                <Box display="flex" justifyContent="space-between" sx={{mb: 2}}>
                    <CustomProvider locale={i18n.resolvedLanguage === 'de' ? deDE : undefined}>
                        <DateRangePicker
                            ranges={getPredefinedRanges(t)}
                            shouldDisableDate={afterToday()}
                            isoWeek
                            // defaultValue={[subDays(new Date(), 6), new Date()]}
                            value={dateRange}
                            onChange={setDateRange}
                            placeholder={t("Select date range")}
                        />
                        <CustomSwitch
                            firstOption={ACTIVE_SCREENS[0]}
                            secondOption={ACTIVE_SCREENS[1]}
                            onChange={setActiveScreen}
                        />
                    </CustomProvider>
                </Box>

                {activeScreen === ACTIVE_SCREENS[0] && (<>
                    <MeasurementsTableData smartReader={smartReader} measurements={measurements}/>
                    <MeasurementsCharts smartReader={smartReader} measurements={measurements}/>
                </>)}
                {activeScreen === ACTIVE_SCREENS[1] && (<>
                    <MetricsCharts smartReader={smartReader} metrics={metrics} />
                </>)}

            </DialogContent>
            <DialogActions sx={{px: 3}}>
                <Button
                    id="show-sr-data-close-button"
                    onClick={handleClose}
                    disableElevation
                    variant="contained"
                    color="warning"
                >
                    {t('Close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PopUpSmartReaderInfo;
